import React from 'react';
import { IconType } from 'react-icons';
import IconBadge from '../icons/IconBadge';

interface ModalHeaderProps {
  icon: IconType;
  title: string;
  subtitle?: string;
}
export default function ModalHeader({ icon, title, subtitle }: ModalHeaderProps): JSX.Element {
  return (
    <div className="flex gap-[10px]">
      <IconBadge icon={icon} />

      <div className="flex w-full flex-col">
        <h1 className="text-[28px] leading-[32px]">{title}</h1>
        <p>{subtitle}</p>
      </div>
    </div>
  );
}
